function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Tabs, Alert, Tag, Upload, notification } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import SetBiochimie from "./SetBiochimie";
import SetHemato from "./SetHemato";
import SetUrine from "./SetUrine";
import SetIonogramme from "./SetIonogramme";
import SetSerologie from "./SetSerologie";
import SaveDrugData from "./SaveDrugData";
import SaveParasitologie from "./SaveParasitologie";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SaveLaboData = function SaveLaboData(_ref) {
  var candidat = _ref.candidat,
      _handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      file = _useState6[0],
      setFile = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var tabsItem = [{
    key: 1,
    label: /*#__PURE__*/_jsx("b", {
      children: "BIOCHIMIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SetBiochimie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.biochimie != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsx("b", {
      children: "HEMATO"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SetHemato, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.hemato != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsx("b", {
      children: "URINE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SetUrine, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.urine != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 4,
    label: /*#__PURE__*/_jsx("b", {
      children: "IONOGRAMME"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SetIonogramme, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.ionogramme != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 5,
    label: /*#__PURE__*/_jsx("b", {
      children: "ADDICTOLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SaveDrugData, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.drug_test != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 6,
    label: /*#__PURE__*/_jsx("b", {
      children: "SEROLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SetSerologie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.serologie != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 7,
    label: /*#__PURE__*/_jsx("b", {
      children: "PARASITOLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 8,
          children: /*#__PURE__*/_jsx(SaveParasitologie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.parasitologie != null,
            handler: function handler() {
              _handler();

              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("comment", values.comment);
    formData.append("attached_file", file);
    axios.post(Common.baseApiUrl + "setlabodata", formData).then(function (response) {
      if (response.data.status == 200) {
        _handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        padding: "20px",
        background: "#B7693F",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: ["Sauvegarder les donn\xE9s de laboratoire pour le candidat ", /*#__PURE__*/_jsx("b", {
        children: candidat.name
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Tabs, {
      items: tabsItem,
      animated: true
    })]
  });
};

export default SaveLaboData;